export const mainAppFeatureKey = "mainApp";
export const SIDEBAR_CONTENT_TYPES = {
  userDetails: "User Details",
};
